import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zebraDictionary from './style/zebratechnologies/translationDictionary.json';
import canonDictionary from './style/canonfocuspep/translationDictionary.json';
import ricohDictionary from './style/ricoh-rewards/translationDictionary.json';



const appId = process.env.REACT_APP_CLIENTID;
let resources = {};

switch (appId) {
    case "zebratechnologies":
        resources = zebraDictionary;
        break;
    case "ricoh-rewards":
        resources = ricohDictionary;
        break;
    default:
        resources = canonDictionary;
}



i18n
    .use(LanguageDetector) // Automatically detects user language
    .use(initReactI18next) // Passes i18n down to react-i18next
    .init({
        resources: resources,
        fallbackLng: "en", // Default language if detection fails
        detection: {
            convertDetectedLanguage: (lng) => {
                // Splits en-GB to en
                return lng.split('-')[0];
            },
            // order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            order: [
                'querystring', // Use URL query parameter to set language, e.g., ?lng=de
                //'cookie', // Use cookies to remember user language preference
                'localStorage', // Use localStorage to remember user language preference
                'navigator', // Use browser language settings,

            ],
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false // React already escapes values
        }
    });


export default i18n;